import { useEffect, useState, useContext, useRef} from 'react'
import { FaCheckCircle } from 'react-icons/fa'
import Fetch, { GET, Loader } from '../inc/Fetch';
import { useNavigate } from 'react-router-dom';
import '../pages/css/moe.css'
import { MdOutlineError } from 'react-icons/md';

export default function MoeLogin() {

    const navigate = useNavigate();
    const [data, setdata] = useState({})
    const [loading, setLoading] = useState(true)
    const [step, setStep] = useState(0);
    const [error, seterror] = useState(false);

    //window.location= `https://www.altashkeel.net//simplesaml/module.php/core/as_login.php?AuthId=default-sp&ReturnTo=https://www.altashkeel.net/moeLogin`
    async function loadData() {
        let res = await GET(`moeLogin`);
        
        console.log(res);
        
        if (res?.error) {
            
            setTimeout(() => {
                seterror(res?.error);
                setLoading(false);

                setTimeout(() => {
                    // window.location='https://www.altashkeel.net/simplesaml/sp_logout.php'
                }, 3000);
            }, 3000);

            return false;
        }
        
        setdata(res);
        setTimeout(() => {
            setStep(1);
            setLoading(false);

            setTimeout(() => {
                window.location='/'
            }, 3000);
        }, 3000);
    }

    

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className='morLoginBox'>
            {loading && <Loader loaderStyle={{ marginBottom: '240px', zoom:1.5 }} />}
            {error ?
            <div className='inBox'>
                <>
                    <MdOutlineError style={{ color: 'red'}} />
                    <h1>لم تنجح في الدخول</h1>
                    <p>{error}</p>
                </>

                </div>
            :<div className='inBox'>
                {!step ? 
                <>
                    <h1>يتم تسجيل الدخول عبر نظام التعريف الموحد</h1>
                    <p>يرجى الانتظار لحظات، سنقوم بنقلك تلقائياً إلى بوابة الهوية الموحدة لاستكمال تسجيل الدخول بأمان.</p>
                </> : 
                <>
                    <FaCheckCircle />
                    <h1>جارٍ إعادة التوجيه إلى بوابة الهوية الموحدة...</h1>
                    <p>إذا لم يتم إعادة التوجيه تلقائياً، يرجى النقر على الرابط أدناه.</p>
                </>
                }
            </div>}
        </div>
    );


}
